import Grid from "@material-ui/core/Grid";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import DynamicForm from "Component/DynamicForm";
import { ErrorMessages } from "Constants";
import { instance } from "Actions/AxiosInstance";
import { integerinputconverter } from "Component/DynamicForm/Fields/Integer";
import TextField from "@material-ui/core/TextField";
import Jobdescription from "../../../business-configration/commons/components/jobdescription";
import "./index.scss";

class define extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      AllDesignation: [],
      postData: this.props.postData,
      currency: [],
      designationData: [],
      budgettypes: [
        { displayvalue: "1", displayname: "Annual" },
        { displayvalue: "2", displayname: "Monthly" },
        { displayvalue: "3", displayname: "Weekly" },
      ],
      grades: [],
      expanded: false,
    };

    this.onSubmit = this.onSubmit.bind(this);

    this.handleChange = this.handleChange.bind(this);
    this.onSaveDraft = this.onSaveDraft.bind(this);
  }

  async componentDidMount() {
    this.props.onRef({
      onNext: this.onSubmit,
      onSaveDraft: this.state.postData.jobtemplateid ? "" : this.onSaveDraft,
    });
    this.fecthcAllDropdownData();
    this.getCurrency();
  }

  handleExpandClick = (panel) => (event, isExpanded) => {
    // setExpanded(isExpanded ? panel : false); // //previous state manager , now not needed //
    isExpanded
      ? this.setState({ expanded: panel })
      : this.setState({ expanded: false }); // new state manager//
  };

  getCurrency() {
    instance
      .get("subscription/getcurrencycode")
      .then((res) => {
        this.setState({
          currency: res.data.result,
        });
      })
      .catch((error) => {
        const msg =
          error && error.response && error.response.data.error.message;
        this.props.enqueueSnackbar(msg, {
          variant: "error",
        });
      });
  }

  async fecthcAllDropdownData() {
    try {
      const data = {
        featurekey: "requestCenter",
      };
      const dropdownData = await instance.post(
        `subscription/initnewemployee`,
        data,
      );
      // const dropdownData = await instance.post(
      //   `subscription/grade`,
      //   data,
      // );
      const allGrade = await instance.get(`subscription/gradelist`);
      console.log("allGrade: ", allGrade);
      const designationArray = [];
      dropdownData.data.result.AllDesignation.forEach((element) => {
        element.options.forEach((desingation) => {
          if (desingation.label && desingation.value) {
            designationArray.push({
              displayname: desingation.label,
              displayvalue: desingation.value,
            });
          }
        });
      });
      await this.setState({
        AllOfficeAddresses: dropdownData.data.result.AllOfficeAddresses,
        AllDesignation: designationArray,
        grades: allGrade.data.result,
      });
    } catch (e) {
      console.log(e);
    }
  }

  onSaveDraft() {
    const { postData } = this.state;
    postData.isdraft = true;
    if (!postData.designationid && !postData.minworkexperience && !postData.maxworkexperience && !postData.budgettypeid && !postData.currencycode && !postData.minbudget && !postData.maxbudget && !postData.gradeid) {
      this.props.enqueueSnackbar("Please select or enter any data", {
        variant: "error",
      });
    } 
    // else if (!postData.minworkexperience) {
    //   this.props.enqueueSnackbar("Please select minimun work experience", {
    //     variant: "error",
    //   });
    // } else if (!postData.maxworkexperience) {
    //   this.props.enqueueSnackbar("Please select maximum work experience", {
    //     variant: "error",
    //   });
    // } else if (!postData.budgettypeid) {
    //   this.props.enqueueSnackbar("Please select budget type", {
    //     variant: "error",
    //   });
    // } else if (!postData.currencycode) {
    //   this.props.enqueueSnackbar("Please select Currency type", {
    //     variant: "error",
    //   });
    // } else if (!postData.minbudget) {
    //   this.props.enqueueSnackbar("Please Enter minimum Budget", {
    //     variant: "error",
    //   });
    // } else if (!postData.maxbudget) {
    //   this.props.enqueueSnackbar("Please Enter maximum Budget", {
    //     variant: "error",
    //   });
    // } else if (!postData.gradeid) {
    //   this.props.enqueueSnackbar("Please select grade", {
    //     variant: "error",
    //   });
    // } 
    else {
      instance
        .post("recruit/configjobtemplate", postData)
        .then(() => {
          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
          this.props.history.push(`${this.props.match.path}/list`);
          this.props.getAllJobTemplate();
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  handleChange(key, value) {
    const { postData } = this.state;
    postData[key] = value;
    // if (key == "designationid") {
    //   this.setState({ postData }, () => this.getData(postData));
    // } else {
    this.setState({ postData });
    // }
  }

  onSubmit() {
    const { postData } = this.state;
    if (!postData.designationid) {
      this.props.enqueueSnackbar("Please select designation of job role", {
        variant: "error",
      });
    } else if (postData.minworkexperience < 0) {
      this.props.enqueueSnackbar("Please select minimun work experience", {
        variant: "error",
      });
    } else if (!postData.maxworkexperience) {
      this.props.enqueueSnackbar("Please select maximum work experience", {
        variant: "error",
      });
    } else if (!postData.budgettypeid) {
      this.props.enqueueSnackbar("Please select budget type", {
        variant: "error",
      });
    } else if (!postData.currencycode) {
      this.props.enqueueSnackbar("Please select Currency type", {
        variant: "error",
      });
    } else if (!postData.minbudget) {
      this.props.enqueueSnackbar("Please Enter minimum Budget", {
        variant: "error",
      });
    } else if (!postData.maxbudget) {
      this.props.enqueueSnackbar("Please Enter maximum Budget", {
        variant: "error",
      });
    } else if (
      postData.minworkexperience &&
      postData.maxworkexperience &&
      postData.maxworkexperience < postData.minworkexperience
    ) {
      this.props.enqueueSnackbar("Please enter experience range", {
        variant: "error",
      });
    } else if (
      postData.maxbudget &&
      postData.minbudget &&
      postData.maxbudget < postData.minbudget
    ) {
      this.props.enqueueSnackbar("Please enter budget", {
        variant: "error",
      });
    } else {
      this.props.onNextClick(postData);
    }
  }

  render() {
    const { postData, AllDesignation } = this.state;

    return (
      <Grid container>
        <Grid item xs={12} md={12} sm={12}>
          <div>
            <div className="display-flex" style={{ alignItems: "center" }}>
              <div style={{ width: 300, marginRight: 24 }}>
                <DynamicForm
                  fields={selectinputconverter({
                    value: postData.designationid,
                    placeholder: "Select Designation",
                    label: "Designation of job role",
                    options: AllDesignation,
                  })}
                  onChange={(selectedid) => {
                    this.handleChange("designationid", selectedid);
                  }}
                />
              </div>
              {postData.designationid && (
                <Jobdescription postData={this.state.postData} />
              )}
            </div>
          </div>

          <div style={{ width: 300 }}>
            {/* <DynamicForm
                fields={textinputconverter({
                  value: jobcode,
                  placeholder: "",
                  label: "Unique job code",
                })}
                onChange={(value) => {
                  this.handleChange("jobcode", value);
                }}
                onBlur={(value) => {
                  this.handleBlur(value, "jobcode");
                }}
              /> */}

            <div>
              <p className="input-label">Work experience range</p>
              <span className="floatleft" style={{ width: 100 }}>
                <TextField
                  margin="dense"
                  variant="outlined"
                  placeholder="Min"
                  InputProps={{
                    inputProps: {
                      min: 0,
                    },
                  }}
                  onChange={(e) => {
                    this.handleChange("minworkexperience", e.target.value);
                  }}
                  value={postData.minworkexperience}
                  type="number"
                />
              </span>
              <p
                className="small-dark-secondary floatleft margin-top-10"
                style={{ margin: 8 }}
              >
                -
              </p>
              <span className="floatleft margin-right-8" style={{ width: 100 }}>
                <TextField
                  margin="dense"
                  variant="outlined"
                  placeholder="Max"
                  InputProps={{
                    inputProps: {
                      min: 0,
                    },
                  }}
                  onChange={(e) => {
                    this.handleChange("maxworkexperience", e.target.value);
                  }}
                  value={postData.maxworkexperience}
                  type="number"
                />
              </span>
              <span className="small-dark-secondary margin-top-8 inline-display">
                years
              </span>
            </div>

            <div style={{ marginTop: 28 }}>
              <DynamicForm
                fields={selectinputconverter({
                  value: postData.budgettypeid,
                  placeholder: "Select budget type",
                  label: "Budget type",
                  options: this.state.budgettypes,
                })}
                onChange={(value) => {
                  this.handleChange("budgettypeid", value);
                }}
              />
            </div>
            <DynamicForm
              fields={selectinputconverter({
                value: postData.currencycode,
                placeholder: "Select currency",
                label: "Currency",
                options: this.state.currency,
              })}
              onChange={(selectedid) => {
                this.handleChange("currencycode", selectedid);
              }}
            />
            <div>
              <p className="input-label">Budget range</p>
              <span className="floatleft" style={{ width: "46%" }}>
                <DynamicForm
                  fields={integerinputconverter({
                    value: postData.minbudget,
                    placeholder: "Min",
                    label: "",
                  })}
                  onChange={(value) => {
                    this.handleChange("minbudget", value);
                  }}
                />
              </span>
              <p
                className="small-dark-secondary floatleft margin-top-10"
                style={{ margin: 8 }}
              >
                -
              </p>
              <span className="floatleft" style={{ width: "46%" }}>
                <DynamicForm
                  fields={integerinputconverter({
                    value: postData.maxbudget,
                    placeholder: "Max",
                    label: "",
                  })}
                  onChange={(value) => {
                    this.handleChange("maxbudget", value);
                  }}
                />
              </span>
            </div>
            <DynamicForm
              fields={selectinputconverter({
                value: postData.gradeid,
                placeholder: "Select grade",
                label: "Select Grade(optional)",
                options: this.state.grades,
              })}
              onChange={(selectedid) => {
                this.handleChange("gradeid", selectedid);
              }}
            />
          </div>
        </Grid>
      </Grid>
    );
  }
}
export default withSnackbar(define);
